import { Typography } from '@mui/material';

export default function Subtitle({ value }) {
  return (
    <Typography sx={{ fontWeight: 700, fontSize: '14px' }}>
      {value}
    </Typography>
  );
}
